"use client";

import React from "react";
import { Leaf, WheatOff, Fish, ShieldCheck, Rabbit } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const sealsData = [{
  id: "gaf-certified",
  label: "GAF Certified",
  description: "Eagle Exteriors is a GAF Certified contractor, ensuring the highest standards in roofing installation.",
  iconName: "ShieldCheck"
}, {
  id: "certainteed",
  label: "CertainTeed",
  description: "Master Siding Applicator status providing you with industry-leading warranty protection.",
  iconName: "Leaf"
}, {
  id: "bbb-accredited",
  label: "VELUX CERTIFIED",
  description: "Eagle Exteriors is a VELUX Certified contractor, ensuring the highest standards in Windowinstallation.",
  iconName: "Rabbit"
}, {
  id: "haag-certified",
  label: "OWENS CORNING",
  description: "Certified Owens Crning Preferred Contractor program member.",
  iconName: "Fish"
}, {
  id: "nrca-member",
  label: "NRCA Member",
  description: "Active member of the National Roofing Contractors Association for continuous excellence.",
  iconName: "WheatOff"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "Leaf":
      return Leaf;
    case "WheatOff":
      return WheatOff;
    case "Fish":
      return Fish;
    case "ShieldCheck":
      return ShieldCheck;
    case "Rabbit":
      return Rabbit;
    default:
      return Leaf;
  }
};
export default function QualitySeals() {
  return <section data-section-id="223840" id="industry-certifications" className="w-full bg-muted border-y border-border/40 py-8 md:py-10 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h3 className="font-default text-xl md:text-2xl font-bold text-secondary uppercase tracking-wider">
            Our Professional Credentials
          </h3>
        </div>
        <TooltipProvider delayDuration={100}>
          <div className="flex flex-wrap justify-center items-start gap-8 md:gap-12 lg:gap-20">
            {sealsData.map((seal, i) => {
            const Icon = getIcon(seal.iconName);
            return <div key={seal.id} data-index={i} className="flex-shrink-0">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="group flex flex-col items-center gap-3 cursor-help focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 rounded-none p-2">
                        <div className="flex h-14 w-14 items-center justify-center rounded-none bg-background shadow-sm border border-border/50 transition-transform duration-300 ease-out group-hover:scale-110 group-hover:shadow-md grayscale group-hover:grayscale-0">
                          <Icon className="size-6 text-primary transition-colors duration-300" strokeWidth={2} aria-hidden="true" />
                        </div>
                        <span className="font-default text-xs md:text-sm font-semibold text-secondary uppercase tracking-widest text-center max-w-[120px] leading-tight group-hover:text-primary transition-colors duration-300">
                          {seal.label}
                        </span>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent side="bottom" align="center" className="max-w-[220px] text-center p-3 shadow-lg bg-card border-primary rounded-none" sideOffset={8}>
                      <p className="text-sm font-default leading-relaxed text-foreground">
                        {seal.description}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </div>;
          })}
          </div>
        </TooltipProvider>
      </div>
    </section>;
}